module.exports = __webpack_public_path__ + "static/media/About-us.7cbf4bcc.png";